import { inject, Injectable } from "@angular/core";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { tryParseJson } from "src/app/support/json";

export interface AfterReloadMessage {
  message: string;
  type: "success";
}

@Injectable()
export class AfterReloadMessagesNotifierService {
  private readonly localStorageService = inject(LocalStorageService);

  async push(message: AfterReloadMessage): Promise<void> {
    const currentMessages = tryParseJson<AfterReloadMessage[]>(
      this.localStorageService.getItem("after-reload-messages"),
      []
    );

    currentMessages?.push(message);

    this.localStorageService.setItem(
      "after-reload-messages",
      JSON.stringify(currentMessages)
    );
  }

  async popAll(): Promise<AfterReloadMessage[]> {
    const currentMessages = tryParseJson<AfterReloadMessage[]>(
      this.localStorageService.getItem("after-reload-messages"),
      []
    );

    this.localStorageService.setItem(
      "after-reload-messages",
      JSON.stringify([])
    );

    return currentMessages;
  }
}
